import React, { useState, useEffect } from "react";
import { Table, Pagination, Spin, Divider, Modal } from "antd";
import axios from "axios";
import reportServices from "../../services/report-services";
import { es } from "date-fns/locale/es";
import { useForm } from "react-hook-form";
import { registerLocale, setDefaultLocale } from "react-datepicker";
import farmService from "../../services/farm-service";
import lotService from "../../services/lot-service";
import lineService from "../../services/line-service";
import moment from "moment";
import config from "../../config/config";
import sectionService from "../../services/section-service";
import userService from "../../services/user-service";
import supervisionService from "../../services/supervision-service";
import { ToastContainer, toast } from 'react-toastify';
import Swal from "sweetalert2";


import DatePicker from "react-datepicker";

const UpdateSupervision = () => {

  registerLocale("es", es);
  const start_date = moment().add(-config.DAYS_LESS_MAP, 'd').startOf("day").toDate();
  const end_date = moment().endOf("day").toDate();
  const [endDate, setEndDate] = useState(end_date);

  const escoja = [{ _id: 0, name: "-ESCOJA-" }];
  const [listFarms, setListFarms] = useState(escoja);
  const [listLots, setListLots] = useState(escoja);
  const [listLines, setListLines] = useState(escoja);
  const [listSection, setListSection] = useState(escoja);
  const [listSupervisors, setListSupervisors] = useState(escoja);
  const [listUsers, setListUsers] = useState(escoja);
  const [isModalOpen, setIsModalOpen] = useState(false);
  ///Aplicaciones por dia
  const [initReport, setInitReport] = useState(false);


  const [idSupervision, setIdSupervision] = useState("");
  const [lotName, setLotName] = useState("");
  const [lineName, setLineName] = useState("");
  const [palmName, setPalmName] = useState("");
  const [quantity, setQuantity] = useState("");
  const [bunches, setBunches] = useState("");
  const [bunchesReported, setBunchesReported] = useState("");
  const [applicationName, setApplicationName] = useState("");



  const [farmId, setFarmId] = useState("0");
  const [sectionId, setSectionId] = useState("0");
  const [lotId, setLotId] = useState("0");



  const {
    register,
    getValues,
    setValue,
    formState: { errors },
  } = useForm();

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingSave, setLoadingSave] = useState(false);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [total, setTotal] = useState(0);






  const deleteSupervision = async (id, line, palm) => {
    const username = localStorage.getItem("username");
    if (username != "superadmin") {
      toast.error('Usuario sin privilegios de edición.', { autoClose: 1000 });
      return;
    }
    else {
      Swal.fire({
        title: `Eliminar registro`,
        html: `Desea eliminar el registro de supervision<br/>Linea ${line} Palma ${palm}?`,
        showDenyButton: false,
        showCancelButton: true,
        confirmButtonText: "Eliminar registro",
        denyButtonText: `Conservar`
      }).then(async (result) => {
        if (result.isConfirmed) {
          const data = { id };
          const success = await supervisionService.deleteSupervision(data);
          if (success) {
            searchMovements(10)
            setIsModalOpen(false)
            toast('Realizado.', { autoClose: 1000 });
          }
        }
      });
    }
  }





  const getListSupervisors = async () => {
    let listado = await userService.getListByRol("SUPERVISOR");
    if (listado) {
      listado.push({ _id: 0, name: "-ESCOJA-" });
      const sortedItems = listado.sort((a, b) => a.name.localeCompare(b.name));
      setListSupervisors(sortedItems);
    }
  };

  const getLisUsers = async () => {
    let listado = await userService.getListByRol("OPERADOR");
    if (listado) {
      listado.push({ _id: 0, name: "-ESCOJA-" });
      const sortedItems = listado.sort((a, b) => a.name.localeCompare(b.name));
      setListUsers(sortedItems);
    }
  };




  const getListFilterUsers = async () => {
    const userId = "0"
    try {
      let start = moment(endDate).startOf("day").format('YYYY-MM-DD');
      let end = moment(endDate).endOf("day").format('YYYY-MM-DD');
      const response = await userService.listInAccumulation(start, end, farmId, sectionId, lotId)
      const listado = response.data
      if (listado) {
        listado.push({ _id: 0, name: "-ESCOJA-" });
        const sortedItems = listado.sort((a, b) => a.name.localeCompare(b.name));
        setListUsers(sortedItems);
      }
    } catch (error) { }
  }



  const getLisFarm = async () => {
    let listado = await farmService.getList();
    if (listado) {
      listado.push({ _id: 0, name: "-ESCOJA-" });
      const sortedItems = listado.sort((a, b) => a.name.localeCompare(b.name));
      setListFarms(sortedItems);
    }
  };

  const getListSection = async (e) => {
    const code = e.target.value;
    if (code == "0") {
      setListSection(escoja);
      setListLots(escoja);
      setValue("section", "0")
      setValue("lot", "0")
      return;
    }
    let listado = await sectionService.getListByFarm(code);
    listado.push({ _id: 0, name: "-ESCOJA-" });
    if (listado) {
      const sortedItems = listado.sort((a, b) => a.name.localeCompare(b.name));
      setListSection(sortedItems);
      setValue("section", "0")
      setValue("lot", "0")
      setValue("line", "0")
    }
  };



  const getLisLots = async (e) => {
    const code = e.target.value;
    if (code == "0") {
      setListLots(escoja);
      setValue("lot", "0")
      setValue("line", "0")
      return;
    }
    let listado = await lotService.getListBySection(code);
    listado.push({ _id: 0, name: "-ESCOJA-" });
    if (listado) {
      const sortedItems = listado.sort((a, b) => a.name.localeCompare(b.name));
      setListLots(sortedItems);
      setValue("lot", "0")
      setValue("line", "0")
    }
  };

  const getListLines = async (e) => {
    const code = e.target.value;
    if (code == "0") {
      setListLines(escoja);
      return;
    }
    let listado = await lineService.getList(code);
    listado.unshift({ _id: 0, name: "-ESCOJA-" });


    if (listado) {
      const sortedList = [...listado].sort((a, b) => {
        const numA = parseInt(a.name);
        const numB = parseInt(b.name);
        return numA - numB;
      });

      setListLines(sortedList);
      setValue("line", "0")
    }

  };


  const markSupervisionsAsPending = async () => {
    let end = moment(endDate).endOf("day").format('YYYY-MM-DD');

    setLoading(true);
    try {
      const farmId = getValues("farm")
      const sectionId = getValues("section")
      const lotId = getValues("lot")
      const userId = getValues("user")
      const lineId = getValues("line")
      const operatorId = getValues("operator")
      await supervisionService.markSupervisionsAsPending(end, end, farmId, sectionId, lotId, userId)
      await supervisionService.synchronizePending(end, end, farmId, sectionId, lotId, userId)
    } catch (error) {
      console.error("Error al desmarcar:", error);
    } finally {
      setLoading(false);
    }


  }



  const searchMovements = async (pageSize) => {
    setInitReport(true)

    let end = moment(endDate).endOf("day").format('YYYY-MM-DD');

    setLoading(true);
    try {
      const farmId = getValues("farm")
      const sectionId = getValues("section")
      const lotId = getValues("lot")
      const userId = getValues("user")
      const lineId = getValues("line")
      const operatorId = getValues("operator")
      const updated = getValues("updated")
      //setPage(1);      
      await supervisionService.synchronizePending(end, end, farmId, sectionId, lotId, userId)
      const response = await reportServices.supervisionReportLine(1, pageSize, end, end, farmId, sectionId, lotId, userId, lineId, operatorId,updated);
      setData(response.data);
      setTotal(response.total);
    } catch (error) {
      console.error("Error al obtener los movimientos:", error);
    } finally {
      setLoading(false);
    }
  }

  const fetchMovements = async (page, pageSize) => {

    if (!initReport) return;



    let end = moment(endDate).endOf("day").format('YYYY-MM-DD');

    setLoading(true);
    try {
      const farmId = getValues("farm")
      const sectionId = getValues("section")
      const lotId = getValues("lot")
      const userId = getValues("user")
      const operatorId = getValues("operator")
      const lineId = getValues("line")
      const updated = getValues("updated")
      const response = await reportServices.supervisionReportLine(page, pageSize, end, end, farmId, sectionId, lotId, userId, lineId, operatorId,updated);
      setData(response.data);
      setTotal(response.total);
    } catch (error) {
      console.error("Error al obtener los movimientos:", error);
    } finally {
      setLoading(false);
    }
  };


  const getSupervision = async (id_application, lot_id, lot_name, line_name, palm_name, quantity_bunches, quantity_bunches_reported) => {



    const username = localStorage.getItem("username");
    if (username != "superadmin") {
      toast.error('Usuario sin privilegios de edición.', { autoClose: 1000 });
      return;
    }

    setIdSupervision(id_application)
    setLotId(lot_id)
    setLotName(lot_name)
    setLineName(line_name)
    setPalmName(palm_name)
    setBunches(quantity_bunches)
    setBunchesReported(quantity_bunches_reported)

    setValue("new_line", line_name)
    setValue("new_palm", palm_name)




    try {

    } catch (error) {
      console.error("Error al obtener los movimientos:", error);
    } finally {

    }

    setIsModalOpen(true);




  }

  const getNameApplication = (code) => {
    switch (code) {
      case 1:
        return "1ra Aplicación";
      case 2:
        return "2da Aplicación";
      case 3:
        return "3ra Aplicación";
      case 0:
        return "Sin Aplicación";
      default:
        return "Desconocido";
    }
  };


  const saveChanges = async () => {

    setLoadingSave(true)
    const new_line = getValues("new_line")
    const new_palm = getValues("new_palm")
    console.log("salvando idSupervision:", idSupervision)
    console.log("salvando newLineName:", new_line)
    console.log("salvando newPalmName:", new_palm)

    const data = { id: idSupervision, lotId, newLine: new_line, newPalm: new_palm };
    const success = await supervisionService.updateSupervision(data);
    if (success) {
      searchMovements(10)
      setIsModalOpen(false)
      toast('Realizado.', { autoClose: 1000 });
    }
    setLoadingSave(false)


  }







  const handlePageChange = (page, pageSize) => {
    setPage(page);
    setPageSize(pageSize);
  };

  const columns = [
    {
      title: "Fecha",
      dataIndex: "date",
      key: "date",
      render: (text) => new Date(text).toLocaleDateString(),
    },
    {
      title: "Usuario",
      dataIndex: "userName",
      key: "userName",
    },
    {
      title: "Finca",
      dataIndex: "farmName",
      key: "farmName",
    },
    {
      title: "Cantidad",
      dataIndex: "quantity",
      key: "quantity",
    },
    // Agrega más columnas según sea necesario
  ];


  useEffect(() => {
    getListFilterUsers()
  }, [endDate, farmId, sectionId, lotId]);


  useEffect(() => {
    getLisFarm();
    getListSupervisors()
    //getLisUsers()
    getListFilterUsers()
  }, []);

  useEffect(() => {
    fetchMovements(page, pageSize);
  }, [page, pageSize]);

  return (
    <div className="row p-4">
      <ToastContainer />
      <div className="col-12 " style={{ marginTop: "-10px" }}>
        <Divider orientation="left" style={{ border: "#AAAAAA" }} >Edición de supervisión</Divider>
      </div>

      <div className="col-12">
        <form className="form-react">
          <div className="row mb-3">
            <div className="col-12 col-sm-10">
              <div className="row">



                <div className=" col-12 col-sm-3">
                  <label className="text-secondary fw-bold">Finca</label>
                  <select
                    className="form-control text-secondary"
                    {...register("farm")}
                    onChange={(e) => {
                      getListSection(e)
                      const value = e.target.value
                      setFarmId(value)
                    }
                    }
                  >
                    {listFarms.map((option) => (
                      <option key={option._id} value={option._id}>
                        {option.name}
                      </option>
                    ))}
                  </select>
                </div>



                <div className=" col-12 col-sm-3">
                  <label className="text-secondary fw-bold">Sección</label>
                  <select
                    className="form-control text-secondary"
                    {...register("section")}
                    onChange={(e) => {
                      getLisLots(e)
                      const value = e.target.value
                      setSectionId(value)
                    }
                    }
                  >
                    {listSection.map((option) => (
                      <option key={option._id} value={option._id}>
                        {option.name}
                      </option>
                    ))}
                  </select>
                </div>

                <div className=" col-12 col-sm-3">
                  <label className="text-secondary fw-bold">Lote</label>
                  <select
                    className="form-control text-secondary"
                    {...register("lot")}
                    onChange={
                      (e) => {
                        getListLines(e)
                        const value = e.target.value
                        setLotId(value)
                      }
                    }
                  >
                    {listLots.map((option) => (
                      <option key={option._id} value={option._id}>
                        {option.name}
                      </option>
                    ))}
                  </select>
                </div>




                <div className=" col-12 col-sm-3">
                  <label className="text-secondary fw-bold">Supervisor</label>
                  <select
                    className="form-control text-secondary"
                    {...register("user")}
                    onChange={(e) => {
                      const value = e.target.value;
                    }}
                  >
                    {listSupervisors.map((option) => (
                      <option key={option._id} value={option._id}>
                        {option.name}
                      </option>
                    ))}
                  </select>
                </div>


                <div className=" col-12 col-sm-3">
                  <label className="text-secondary fw-bold">Polinizador</label>
                  <select
                    className="form-control text-secondary"
                    {...register("operator")}
                    onChange={(e) => {
                      const value = e.target.value;
                    }}
                  >
                    {listUsers.map((option) => (
                      <option key={option._id} value={option._id}>
                        {option.name}
                      </option>
                    ))}
                  </select>
                </div>





                <div className=" col-12 col-sm-3">
                  <label className="text-secondary fw-bold">Linea</label>
                  <select
                    className="form-control text-secondary"
                    {...register("line")}
                    onChange={(e) => {
                      const value = e.target.value;
                      //setValue("user", "0")
                    }}
                  >
                    {listLines.map((option) => (
                      <option key={option._id} value={option._id}>
                        {option.name}
                      </option>
                    ))}
                  </select>
                </div>



                <div className=" col-12 col-sm-3">
                  <label className="text-secondary fw-bold">Fecha</label>
                  <br />
                  <DatePicker
                    locale="es"
                    dateFormat="yyyy-MM-dd"
                    className="form-control 
                              text-secondary"
                    selected={endDate}
                    onChange={(date) => setEndDate(date)}
                  />
                </div>



                <div className="col-12 col-sm-3">
                  <label className="text-secondary fw-bold">Estado</label>
                  <select className="form-control text-secondary" {...register("updated")}>
                    <option value="true">EMPAREJADOS</option>
                    <option value="false">PENDIENTE DE EMPAREJAR</option>
                  </select>
                </div>


              </div>
            </div>


            <div className="col-12 col-sm-2">






              <div className=" col-12">
                <label className="text-secondary fw-bold">&nbsp;</label>
                <br />
                <Spin spinning={loading}>
                  <button
                    className="btn btn-primary w-100"
                    type="button"
                    onClick={() => searchMovements(pageSize)}
                  >
                    <i className="bi bi-search fa-lg m-2" /> Buscar
                  </button>
                </Spin>
              </div>

              <div className=" col-12">
                <label className="text-secondary fw-bold">&nbsp;</label>
                <br />
                <Spin spinning={loading}>
                  <button
                    className="btn btn-success w-100"
                    type="button"
                    onClick={() => markSupervisionsAsPending()}
                  >
                    <i className="bi bi-arrow-clockwise fa-lg m-2" /> Recalcular fecha
                  </button>
                </Spin>
              </div>



            </div>
          </div>
        </form>
      </div>

      <Pagination
        className="text-primary "
        current={page}
        pageSize={pageSize}
        total={total}
        onChange={handlePageChange}
        pageSizeOptions={["10", "20", "50"]}
        showTotal={(total) => `Total ${total} registros`}
        showSizeChanger
        onShowSizeChange={(current, size) => handlePageChange(1, size)}
      />
      <Spin spinning={loading}>
        <div className="card mt-3" style={{ minHeight: "400px" }}>

          <div className="table-responsive">
            <table className="table">
              <thead className="table-primary">
                <tr>
                  <th>Fecha</th>
                  <th>Supervisor</th>
                  <th>Operario</th>
                  <th>Finca</th>
                  <th>Seccion</th>
                  <th>Lote</th>
                  <th>Línea</th>
                  <th>Palma</th>
                  <th>Encontrados</th>
                  <th>Reportados</th>
                  <th>Confiable</th>
                  <th>Editar</th>
                </tr>
              </thead>
              <tbody>
                {data.map((item, index) => {

                  const nameApplication = getNameApplication(item.applicationType)

                  return (
                    <tr key={index}>
                      <td width="100px" >{item.date.split("T")[0]}</td>
                      <td>{item.userName}</td>
                      <td>{item.operatorName}</td>
                      <td>{item.farmName}</td>
                      <td>{item.sectionName}</td>
                      <td>{item.lotName}</td>
                      <td>{item.lineName}</td>
                      <td>{item.palmName}</td>
                      <td>{item.bunches}</td>
                      <td>{item.bunchesReported}</td>
                      <td>{item.trusted ? "SI" : "NO"}</td>
                      <td>
                        <button
                          className="btn btn-primary"
                          onClick={() => getSupervision(item._id, item.lotId, item.lotName, item.lineName, item.palmName, item.bunches, item.bunchesReported)}
                        >
                          <i className="bi bi-pencil-square fa-lg m-1" />
                        </button>


                        <button
                          className="btn btn-secondary ms-2"
                          onClick={() => deleteSupervision(item._id, item.lineName, item.palmName)}
                        >
                          <i className="bi bi-trash fa-lg m-1" />
                        </button>



                      </td>
                    </tr>
                  )
                }


                )}
              </tbody>
            </table>
          </div>
        </div>
      </Spin>






      <Modal
        title={`MODIFICAR REGISTRO DE LA LINEA:  ${lineName} PALMA: ${palmName}`}
        open={isModalOpen}
        onCancel={() => setIsModalOpen(false)}
        footer={null}
        width="40%"
      >

        <div className="row">

          <div className="col-12 col-sm-6 ">
            <div className="card p-3  bg-light " style={{ height: "200px" }}>
              <p><strong>LOTE:</strong> {lotName}</p>
              <p><strong>LINEA:</strong> {lineName}</p>
              <p><strong>PALMA:</strong> {palmName}</p>
              <p><strong>ENCONTRADOS:</strong> {bunches}</p>
              <p><strong>REPORTADOS:</strong> {bunchesReported}</p>
            </div>
          </div>




          <div className="col-12 col-sm-6">
            <div className="card p-3 bg-light " style={{ height: "200px" }}>

              <form>

                <div className=" col-12 ">
                  <label className="text-secondary fw-bold">NUEVA LÍNEA</label>
                  <input
                    type="number"
                    className="form-control"
                    {...register("new_line")}
                  />
                </div>


                <div className=" col-12 mt-2">
                  <label className="text-secondary fw-bold">NUEVA PALMA</label>
                  <input
                    type="number"
                    className="form-control"
                    {...register("new_palm")}
                  />
                </div>


                <div className=" col-12">
                  <label className="text-secondary fw-bold">&nbsp;</label>
                  <br />
                  <Spin spinning={loadingSave}>
                    <button
                      className="btn btn-primary w-100"
                      type="button"
                      onClick={() => saveChanges()}
                    >
                      <i className="bi bi-save fa-lg m-2" /> Actualizar
                    </button>
                  </Spin>
                </div>



              </form>


            </div>
          </div>


        </div>


      </Modal>

    </div>
  );
};


export default UpdateSupervision;
